import { StoreDepartment } from './models/store-department';

export type DepartmentsState = {
  departments: {
    [clientCode: string]: {
      [departmentId: number]: StoreDepartment;
    };
  };
};

export const initialDepartmentsState: DepartmentsState = {
  departments: {},
};
